export const witnessInitialState = {
  witnessIndexToEdit: null,
  buttonClicked: false,
};

export const witnessReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'ADD':
      return { ...state, witnessIndexToEdit: null, buttonClicked: true };
    case 'EDIT':
      return {
        ...state,
        witnessIndexToEdit: action.payload,
        buttonClicked: true,
      };
    case 'REMOVE':
      return { ...state, witnessIndexToEdit: null, buttonClicked: true };
    default:
      return state;
  }
};
